<template>
  <v-container>
    <!-- If we're editing a user -->
    <EditUser
      :userData="editUser"
      @saved="userUpdateSuccessful"
      @disabled="cancelEdit"
      v-if="isEditMode"
    />

    <!-- If we are not, everything else can happen -->
    <v-layout row wrap class="mb-5" v-else>
      <v-flex xs12>
        <v-layout>
          <h1 class="primary--text mr-3">Admins</h1>
          <v-btn
            small
            depressed
            color="accent"
            :to="`/users/create?type=Admin&role=${roles.admin}&next=/users/admins`"
            v-if="$can('create_user')"
          >
            <v-icon small>add</v-icon>Create Admin
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <app-alert
      class="mb-3"
      type="success"
      message="Admin successfully created."
      v-if="$route.query.userCreated"
    />

    <app-alert class="mb-3" type="success" :message="userUpdated" :dismissible="true"/>

    <!-- Administrators List -->
    <v-layout row wrap v-if="!isEditMode && $can('view_admins')">
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Administrators</v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="adminHeaders"
            :items="admins"
            :loading="adminsLoading"
            :rows-per-page-items="[30, 60, 100]"
            no-data-text="No admins available"
            :hide-actions="admins.length < 5"
          >
            <template v-slot:items="props">
              <td> {{ (props.index + 1) }} </td>
              <td class="py-3">{{ props.item.name }}</td>
              <td class="py-3">{{ props.item.email }}</td>
              <td>
                <v-chip
                  small
                  :color="props.item.status === 'active' ? 'green' : 'red'"
                  text-color="white"
                  style="text-transform: capitalize"
                >{{ props.item.status }}</v-chip>
              </td>
              <td>
                <v-icon
                  small
                  class="mr-2"
                  @click="enableEditMode(props.item)"
                  v-if="currentUser._id !== props.item._id"
                >edit</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { USER_FETCH } from '@/store/actions/user'
import rolesData from '@/data/roles'

import EditUser from './components/EditUser.vue'
import editUserMixin from './mixins/editUser'

export default {
  name: 'Admins',
  components: {
    EditUser
  },
  mixins: [editUserMixin],
  created () {
    if (this.$can('view_admins')) {
      this.fetchUsers(true, 'adminsLoading')
    }
  },
  data () {
    return {
      roles: rolesData,
      adminsLoading: false,
      adminHeaders: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ]
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'admins'])
  },
  methods: {
    fetchUsers (isAdmin, loader) {
      this[loader] = true
      this.$store.dispatch(USER_FETCH, { isAdmin })
        .finally(() => (this[loader] = false))
    }
  }
}
</script>
